// extracted by mini-css-extract-plugin
module.exports = {"market":"Market_market__3YKJT","table":"Market_table__3yTZh","row":"Market_row__1Q-AQ","col":"Market_col__34cs8","foot":"Market_foot__3xnYE","arrow":"Market_arrow__cdg8W"};